import dartIcon from '../../assets/icons/dart.png';
import socialActionsIcon from '../../assets/icons/social_actions.png';
// import ticketIcon from '../../assets/icons/tickets.png';
import playButtonIcon from '../../assets/icons/play_button.png';
import { ReactComponent as BlueChevronRight } from '../../assets/icons/chevron-right-blue.svg';
import { useContext, useEffect, useState } from 'react';
import useSWR, { useSWRConfig } from 'swr';
import { AuthContext } from '../../context/AuthContext';
import { getClaimOfferwallMissionSnacksUrl, getGetMissionInfoUrl } from '../../api/generated/time-nyang/main/main.ts';
import { useToast } from '../../context/ToastContext';
import { useNavigate } from 'react-router';

const missionItems = [
  {
    id: 'mission-participation',
    icon: dartIcon,
    title: '참여 간식 미션',
    tier: 1,
    defaultReward: 15,
  },
  {
    id: 'mission-social',
    icon: socialActionsIcon,
    title: 'SNS 간식 미션',
    tier: 2,
    defaultReward: 40,
  },
  // {
  //   id: 'mission-ticket',
  //   icon: ticketIcon,
  //   title: '광고 스킵권',
  //   description: '1500P 획득 > 스킵권 최대 30장',
  //   progress: '0/1500P',
  // },
  // {
  //   id: 'mission-ad-watch',
  //   icon: playButtonIcon,
  //   title: '광고 시청 추천',
  //   description: '언제나 풍족하게 충전 가능',
  // },
  {
    id: 'go-snack-charge',
    icon: playButtonIcon,
    title: '간식 충전소',
    description: '매일 간식 받기 가능',
    openSnackShop: true,
  },
];

function PlaygroundMissionCard({ onOpenOfferwall }) {
  const navigate = useNavigate();
  const { API_SERVER_DOMAIN, useAccessToken, fetchWithToken } = useContext(AuthContext);
  const { showToast, showErrorToast } = useToast();
  const { mutate } = useSWRConfig();
  const accessToken = useAccessToken();
  const [pendingTier, setPendingTier] = useState(null);
  const [currentTime, setCurrentTime] = useState(() => Date.now());
  const missionInfoKey = accessToken && [`${API_SERVER_DOMAIN}${getGetMissionInfoUrl()}`, accessToken];
  const eggInfoKey = accessToken && [`${API_SERVER_DOMAIN}/game/egg/userGameInfo`, accessToken];
  const profileInfoKey = accessToken && [`${API_SERVER_DOMAIN}/user/profile/info`, accessToken];
  const { data: missionInfo } = useSWR(missionInfoKey, fetchWithToken);
  const missionPoint = Number.isFinite(missionInfo?.missionPoint) ? missionInfo.missionPoint : 0;
  const missionList = Array.isArray(missionInfo?.missionList) ? missionInfo.missionList : [];

  useEffect(() => {
    if (!missionInfo?.missionEndDate) return undefined;

    setCurrentTime(Date.now());
    const intervalId = window.setInterval(() => {
      setCurrentTime(Date.now());
    }, 60000);

    return () => window.clearInterval(intervalId);
  }, [missionInfo?.missionEndDate]);

  const getMissionTierInfo = (tier) => {
    if (!Number.isFinite(tier)) return null;
    const byIndex = missionList[tier - 1];
    if (byIndex && typeof byIndex === 'object') return byIndex;

    const byTierName = missionList.find((entry) => {
      if (!entry || typeof entry !== 'object') return false;
      return typeof entry.name === 'string' && entry.name.includes(`${tier}단계`);
    });
    if (byTierName && typeof byTierName === 'object') return byTierName;

    const nestedTier = missionList.find(
      (entry) => entry && typeof entry === 'object' && (entry[tier] || entry[String(tier)]),
    );
    return nestedTier?.[tier] ?? nestedTier?.[String(tier)] ?? null;
  };

  const isClaimedTier = (tier) => {
    const missionTierInfo = getMissionTierInfo(tier);
    if (!missionTierInfo || typeof missionTierInfo !== 'object') return false;
    if (!Number.isFinite(missionTierInfo.count)) return false;
    return missionTierInfo.count !== 0;
  };

  const getTierReward = (tier, fallbackReward = 0) => {
    const missionTierInfo = getMissionTierInfo(tier);
    const serverReward = Number(missionTierInfo?.reward);
    if (Number.isFinite(serverReward) && serverReward > 0) return serverReward;
    return fallbackReward;
  };

  const getTierTargetPoint = (tier, fallbackTargetPoint = null) => {
    const missionTierInfo = getMissionTierInfo(tier);
    const serverTargetPoint = Number(missionTierInfo?.targetPoint);
    if (Number.isFinite(serverTargetPoint) && serverTargetPoint > 0) return serverTargetPoint;
    return fallbackTargetPoint;
  };

  const getMissionTitle = (item) => {
    if (!item?.tier) return item?.title ?? '';
    const missionTierInfo = getMissionTierInfo(item.tier);
    return missionTierInfo?.title ?? item.title;
  };

  const getMissionDescription = (item) => {
    if (!item?.tier) return item?.description ?? '';
    const targetPoint = getTierTargetPoint(item.tier, item.targetPoint);
    if (!targetPoint) return item?.description ?? '';
    const reward = getTierReward(item.tier, item.defaultReward ?? 0);
    return `${targetPoint.toLocaleString()}P 획득 > 간식 ${reward.toLocaleString()}개 받기`;
  };

  const getMissionProgressLabel = (targetPoint) => {
    if (!Number.isFinite(targetPoint) || targetPoint <= 0) return null;
    if (missionPoint >= targetPoint) return '받기';
    return `${missionPoint.toLocaleString()}/${targetPoint.toLocaleString()}P`;
  };

  const getMissionRemainingLabel = () => {
    const missionEndTime = Date.parse(missionInfo?.missionEndDate ?? '');
    if (!Number.isFinite(missionEndTime)) return null;

    const diff = Math.max(0, missionEndTime - currentTime);
    const dayMs = 24 * 60 * 60 * 1000;
    const hourMs = 60 * 60 * 1000;
    const days = Math.floor(diff / dayMs);
    const hours = Math.floor((diff % dayMs) / hourMs);

    return `~ ${days}d ${hours}h`;
  };

  const missionRemainingLabel = getMissionRemainingLabel();
  const openSnackShop = () => {
    navigate('/game/yaong-egg/shop');
  };

  const handleMissionClick = async ({ isCompleted, isClaimable, tier, openSnackShop: shouldOpenSnackShop }) => {
    if (shouldOpenSnackShop) {
      openSnackShop();
      return;
    }
    if (isCompleted) return;
    if (isClaimable && Number.isFinite(tier) && accessToken) {
      try {
        setPendingTier(tier);
        const response = await fetch(`${API_SERVER_DOMAIN}${getClaimOfferwallMissionSnacksUrl(tier)}`, {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
          },
        });
        const payload = await response.json().catch(() => null);
        if (!response.ok || payload?.result === 'fail') {
          showErrorToast(payload?.message || '보상 지급에 실패했어요.');
          throw new Error(payload?.message || `SNACK_CLAIM_FAILED_${response.status}`);
        }
        showToast(payload?.message || '보상이 지급되었습니다.');

        const awardedSnackCount = Number.isFinite(payload?.snackCount) ? payload.snackCount : 0;

        if (missionInfoKey) {
          await mutate(
            missionInfoKey,
            (current) => {
              const currentList = Array.isArray(current?.missionList) ? [...current.missionList] : [];
              currentList[tier - 1] = { ...(currentList[tier - 1] ?? {}), count: 1 };
              return {
                ...(current ?? {}),
                missionPoint: Number.isFinite(payload?.missionPoint)
                  ? payload.missionPoint
                  : Number.isFinite(current?.missionPoint)
                    ? current.missionPoint
                    : 0,
                missionList: currentList,
              };
            },
            { revalidate: false },
          );
        }

        if (eggInfoKey && awardedSnackCount > 0) {
          await mutate(
            eggInfoKey,
            (current) => ({
              ...(current ?? {}),
              userEggGameInfo: {
                ...(current?.userEggGameInfo ?? {}),
                snackCount: Math.max(0, Number(current?.userEggGameInfo?.snackCount ?? 0) + awardedSnackCount),
              },
            }),
            { revalidate: false },
          );
        }

        // 응답 직후 실제 사용자 포인트/간식 정보를 서버 기준으로 재조회
        if (profileInfoKey) {
          await mutate(profileInfoKey);
        }
        if (eggInfoKey) {
          await mutate(eggInfoKey);
        }
      } catch (error) {
        console.error('POST /main/missionReward/snack/{tier} failed', { tier, error });
      } finally {
        setPendingTier(null);
      }
      return;
    }
    if (typeof onOpenOfferwall === 'function') onOpenOfferwall();
  };

  return (
    <div className="flex w-full pb-5 pt-3">
      <div className="w-full rounded-[10px] bg-white p-5 shadow-[0px_5px_16px_0px_rgba(0,0,0,0.09)]">
        <div className="pb-2.5 text-sm font-extrabold text-gray03 font-['Pretendard']">
          조금 시간 쓰고, 간식 왕창 받기 !
        </div>

        <div className="flex flex-col gap-1">
          {missionItems.map((item, index) => {
            const isSnackShopItem = Boolean(item.openSnackShop);
            const targetPoint = item.tier ? getTierTargetPoint(item.tier, item.targetPoint) : item.targetPoint;
            const missionTitle = getMissionTitle(item);
            const isCompleted = item.tier ? isClaimedTier(item.tier) : false;
            const progressLabel = isCompleted ? '완료' : getMissionProgressLabel(targetPoint);
            const isClaimable = progressLabel === '받기';
            const isLoading = pendingTier === item.tier;
            const isInteractive = isSnackShopItem
              ? true
              : !isCompleted && (isClaimable || typeof onOpenOfferwall === 'function');
            return (
              <div
                key={item.id}
                onClick={
                  isInteractive && !isLoading
                    ? () =>
                        handleMissionClick({
                          isCompleted,
                          isClaimable,
                          tier: item.tier,
                          openSnackShop: item.openSnackShop,
                        })
                    : undefined
                }
                className={`flex w-full items-center justify-between rounded-[10px] text-left ${isInteractive && !isLoading ? 'cursor-pointer' : ''} ${isCompleted || isLoading ? 'opacity-45' : ''} ${index === missionItems.length - 1 ? '' : 'py-[5px]'}`}
              >
                <div className="flex items-center gap-4">
                  <div className="flex h-12 w-12 items-center justify-center rounded-[10px] bg-[#F0ECFF]">
                    <img src={item.icon} alt="" className="h-[36px] w-[36px] object-contain" />
                  </div>

                  <div className="inline-flex flex-col items-start gap-0.5">
                    <div className="flex items-center gap-1.5">
                      <div className="text-base font-bold text-gray05 font-['Pretendard']">{missionTitle}</div>
                      {item.tier && missionRemainingLabel ? (
                        <span className="text-xs font-medium text-gray03 font-['Pretendard']">
                          ({missionRemainingLabel})
                        </span>
                      ) : null}
                    </div>
                    <div className="text-xs font-medium text-gray03 font-['Pretendard']">
                      {getMissionDescription(item)}
                    </div>
                  </div>
                </div>

                <div className="flex items-center gap-2.5">
                  {targetPoint ? (
                    <div className="flex items-center justify-center rounded-[3px] bg-background01 px-[5px] py-[3px]">
                      <span className="text-[0.6875rem] font-bold text-primary-blue font-['Pretendard']">
                        {isLoading ? '처리중' : progressLabel}
                      </span>
                    </div>
                  ) : null}
                  <BlueChevronRight className="h-[10px] w-[5px]" />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default PlaygroundMissionCard;
